/**
 * Returns true if the user is using a mobile device (phone or tablet).
 * @return {boolean}
 */
export function isOnMobileDevice() {
  return isOnIosDevice() || isOnAndroidDevice()
}

/**
 * Returns true if the user is using an Apple device.
 * @return {boolean}
 */
export function isOnAppleDevice() {
  return navigator.platform === 'MacIntel' || isOnIosDevice()
}

/**
 * Returns true if the user is using an iOS device.
 * @return {boolean}
 */
export function isOnIosDevice() {
  return isOnIphone() || isOnIpad() || isOnIpod()
}

/**
 * Returns true if the user is using an Android device.
 * @return {boolean}
 */
export function isOnAndroidDevice() {
  return navigator.userAgent.includes('Android')
}

/**
 * Returns true if the user is using a Samsung device.
 * @return {boolean}
 */
export function isOnSamsungDevice() {
  return !!navigator.userAgent.match(/\sSM-\w+\)?\s/)
}

/**
 * Returns true if the user is using an iPhone.
 * @return {boolean}
 */
export function isOnIphone() {
  return ['iPhone Simulator', 'iPhone'].includes(navigator.platform)
}

/**
 * Returns true if the user is using an iPod.
 * @return {boolean}
 */
export function isOnIpod() {
  return ['iPod Simulator', 'iPod'].includes(navigator.platform)
}

/**
 * Returns true if the user is using an iPad.
 * @return {boolean}
 */
export function isOnIpad() {
  return ['iPad Simulator', 'iPad'].includes(navigator.platform)
}
